import { UNASSIGNED } from '../constants/RoutingTypes';
import RoutingRuleBase from './RoutingRuleBase';
export default RoutingRuleBase({
  '@type': UNASSIGNED
}, 'UnassignedRoutingRules');